module.exports = __webpack_public_path__ + "static/standardsitepreview-6315d5ff73eecc60b466b0ea59bd1d67.png";